import { getEmployees } from '@/api/employee';
import { useState, useEffect } from 'react';

interface MetaData {
  total: number;
  lastPage: number;
  currentPage: number;
  perPage: number;
  prev: number | null;
  next: number | null;
}

interface ClientResponse {
  data: Employee[];
  meta: MetaData;
}

export const useEmployees = (
  page: number,
  perPage: number,
  searchTerm: string
) => {
  const [employees, setEmployees] = useState<Employee[]>([]);
  const [meta, setMeta] = useState<MetaData | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const fetchEmployees = async () => {
    setLoading(true);
    try {
      const response: ClientResponse = await getEmployees({
        page,
        perPage,
        searchTerm,
      });
      setEmployees(response.data);
      setMeta(response.meta);
    } catch (err) {
      setError('Failed to fetch employees');
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchEmployees();
  }, [page, perPage, searchTerm]);

  const refresh = () => {
    fetchEmployees();
  };

  return { employees, refresh, meta, loading, error };
};
